export default __webpack_public_path__ + "static/media/CNN.cd3080ec.svg";